import * as PropTypes from 'prop-types'

import {Container, Body, Header, HeaderAction, HeaderText} from './Box.styles'

const Box = ({title, actionText, actionOnClick, customAction, children, withBackBtn, ...rest}) => (
  <Container {...rest}>
    {title && (
      <Header>
        <HeaderText>
          {withBackBtn && withBackBtn}
          {title}
        </HeaderText>
        {customAction}
        {!customAction && actionText && actionOnClick && (
          <HeaderAction onClick={actionOnClick}>{actionText}</HeaderAction>
        )}
      </Header>
    )}
    <Body>{children}</Body>
  </Container>
)

Box.propTypes = {
  title: PropTypes.string,
  actionText: PropTypes.string,
  actionOnClick: PropTypes.func,
  children: PropTypes.node,
  customAction: PropTypes.node,
  withBackBtn: PropTypes.node,
}
Box.defaultProps = {
  children: null,
  customAction: null,
  title: null,
  actionText: null,
  actionOnClick: null,
  withBackBtn: null,
}

export default Box
